import GameState from "slotworks/model/game-state";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class ShouldExitFreespins extends Decision {
    public evaluate() {
        const gameplay = GameState.getCurrentGame();

        return gameplay.areFreespinsPending() ? Exit.False : Exit.True;
    }
}
